<template>
  <div class="home">
    <h1 class="home_title">
      <img style="max-width:100%;" v-lazy="'https://dream.ameneko.com/topImage-home.png'" alt="夢占い辞典ゆめみん">
    </h1>
    <p class="home_subtitle">夢の意味をキーワード検索できる！夢占いサイト</p>
    <div class="app_link">
      <a href='https://play.google.com/store/apps/details?id=com.ameneko.dream&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img alt='Google Play で手に入れよう' src='https://play.google.com/intl/ja/badges/static/images/badges/ja_badge_web_generic.png'/></a>
    </div>
    <div class="keyword_search">
      <h2 class="keyword_title">キーワードで検索</h2>
          <b-field position="is-centered">
            <input v-model="main_input_text" type="text" v-on:keyup.enter="main_enter_search" placeholder=" キーワードを入力（例：火事）" id="">
            <p class="control">
                <b-button @click="mainSearch" type="is-info">検索</b-button>
            </p>
        </b-field>
    </div>
    <div class="share_component">
      <ShareComponent/>
    </div>
    <h2 class="initial_title">夢占いとは？</h2>
    <div class="dream_explain">
    <p>夢占いは、夢のストーリー、登場人物、見た物の特徴から意味を解釈することを言います。</p>
    <p>夢占いの歴史は古く、紀元前8世紀にはすでに夢の意味を診断する「夢占い師」が存在しており、日本では平安時代に「夢解き」や「夢合わせ」という名で、見た夢の内容によって夢の意味や吉凶を判断していました。</p>
    <p>その後、心理学者のフロイトとその弟子のユングが、人々が見る夢の内容と人間の精神状態のつながりに注目し、研究を重ねました。</p>
    <p>当サイト「夢占い辞典ゆめみん」では、夢で見たキーワードから、あなたの見た夢の意味の解釈のお手伝いをします。</p>
    </div>
    <h2 class="initial_title">50音順で検索</h2>
    <p class="initial_subtitle">夢に見たキーワードを頭文字から検索できます</p>
    <div class="initial_component">
      <InitialComponent />
    </div>
    <h2 class="category_title">カテゴリー別</h2>
    <p class="category_subtitle">カテゴリーごとに検索できます</p>
      <CategoryComponent />
      
    <h2 class="theme_title">よくみる夢</h2>
    <p class="theme_subtitle">よく夢に登場するキーワード</p>
      <ThemesComponent />
    <p class="caseList_subtitle"><router-link to="/themeList">よく夢に登場するキーワード一覧</router-link></p>
    <h2 class="caseList_title">個別の夢診断</h2>
    <p class="caseList_subtitle"><router-link to="/caseList">個別の夢診断一覧を見る</router-link></p>
    <h2 class="theme_title">キーワード一覧</h2>
    <p class="theme_subtitle"><router-link to="/articles">キーワードの一覧を見る</router-link></p>
  </div>
</template>

<script>
import InitialComponent from '@/components/InitialComponent.vue'
import ThemesComponent from '@/components/ThemesComponent.vue'
import ShareComponent from '@/components/ShareComponent'
import CategoryComponent from '@/components/CategoryComponent'
export default {
  name: 'home',
  data(){
    return{
      main_input_text: null,
      main_enter_text: ""
    }
  },
  components: {
    InitialComponent,
    ThemesComponent,
    ShareComponent,
    CategoryComponent
  },
  mounted(){
    const title = "夢占い辞典ゆめみん｜夢占い・夢判断・夢診断"
    const description = "この夢の意味は何？夢の中で見たキーワードで、あなたの夢の意味を調べることができる、夢占い・夢診断・夢判断のサイトです。"
    const twitter_image = 'https://dream.ameneko.com/ogpImage.jpeg'
    const og_image = 'https://dream.ameneko.com/topImage.jpeg'
    document.title = title
    document.querySelector("meta[property='og:image']").setAttribute('content', og_image)
    document.querySelector("meta[name='twitter:image']").setAttribute('content', twitter_image)
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  },
  methods:{
    mainSearch(){
      //スペースがあるか？ある場合は複数検索へ飛ばす「\s+」は空白の正規表現
      if(this.main_input_text.match(/\s+/)){
        this.$router.push({ name: 'keywords', params:{ id: this.main_input_text} })
        this.main_input_text = null
        this.main_enter_text = ""
      }else{
        this.$router.push({ name: 'article', params:{ id: this.main_input_text} })
        this.main_input_text = null
        this.main_enter_text = ""
      }
    },
    main_enter_search(){
      if(this.main_input_text == this.main_enter_text){
        if(this.main_input_text.match(/\s+/)){
          this.$router.push({ name: 'keywords', params:{ id: this.main_input_text} })
          this.main_input_text = null
          this.main_enter_text = ""
        }else{
          this.$router.push({ name: 'article', params:{ id: this.main_input_text} })
          this.main_input_text = null
          this.main_enter_text = ""
        }
      }else{
        this.main_enter_text = this.main_input_text
      }
    }
  }
}
</script>

<style scoped>
h2{
  font-size: 1.4em;
  font-weight: bold;
  margin-top:30px;
}
.home{
  max-width: 1080px;
  margin:auto;
  padding:8px;
}
.home_title{
  max-width: 640px;
  margin:auto;
  text-align: center;
}
.app_link{
  margin: auto;
  max-width: 240px;
}
.home_subtitle{
  padding: 8px;
  font-weight: bold;
  font-size:1em;
  text-align: center;
}
.keyword_search{
  text-align: center;
  padding: 120px 0 200px 0;
}
.keyword_title{
  padding: 0 0 24px 0;
}
input{
  width: 500px;
  border: none;
  font-size:1.2em;
  border-radius: 3px;
  border: 1px solid gray;
  padding: 0 0px 0 10px;
}
.dream_explain{
  padding: 10px 4px 10px 4px;
  font-size: 1.1em;
}
.category_title{
  border-bottom: solid 2px #27556A;
}
.category_subtitle{
  padding:8px 8px 24px 8px;
  font-size: 1em;
}
.initial_title{
  border-bottom: solid 2px #27556A;
}
.initial_subtitle{
  padding:8px 8px 24px 8px;
  font-size: 1em;
}
.initial_component{
  max-width: 450px;
}
.theme{
  font-size: 1.2em;
}
.theme_title{
  border-bottom: solid 2px #27556A;
}
.theme_subtitle{
  padding:8px 8px 8px 8px;
  font-size: 1em;
}
.caseList_title{
  border-bottom: solid 2px #27556A;
}
.caseList_subtitle{
  padding:8px 8px 8px 8px;
  font-size: 1em;
}
li{
  padding: 2px; 
}
.share_component{
  text-align: right;
}
</style>
